export const CONTAINER_ID = 'sat-infobox';
// Section IDs
export const SECTIONS = {
    IDENTIFIERS: 'sat-identifier-data',
};
export const EL = {
    // Header elements
    CONTAINER: 'sat-info-header',
    TITLE: 'sat-info-title',
    NAME: 'sat-info-title-name',
    FLAG: 'sat-infobox-fi',
    // Identifier elements
    INTL_DES: 'sat-intl-des',
    OBJNUM: 'sat-objnum',
    ALT_NAME: 'sat-alt-name',
    ALT_ID: 'sat-alt-id',
    SOURCE: 'sat-source',
    CONFIDENCE: 'sat-confidence',
};
